// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownloadSimpleOutlinedSvg from "@fishx/icons-svg/es/asn/DownloadSimpleOutlined";
import FishxIcon from '../components/FishxIcon';

var DownloadSimpleOutlined = function DownloadSimpleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownloadSimpleOutlinedSvg
  }));
};

DownloadSimpleOutlined.displayName = 'DownloadSimpleOutlined';
export default React.forwardRef(DownloadSimpleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DownloadSimpleOutlined.js
// module id = 2465
// module chunks = 0